<form
  class="advanced-form"
  (keydown.enter)="($event.target.tagName === 'TEXTAREA')"
  [formGroup]="form">
  @if (copyConfig) {
    <button
      type="button"
      class="btn btn-transparent text-dark end-tab-button"
      (click)="toggleCopyControl()"
      (keydown.enter)="toggleCopyControl()">
      <i
        class="fa-regular fa-lg"
        [ngClass]="isPartiallySelected() ? 'fa-check-square' : 'fa-square'"></i>
    </button>
  }
  <ul ngbNav #tabmain="ngbNav" class="nav-tabs">
    @if (!apollo) {
      <li [ngbNavItem]="'firmware'" id="firmware">
        <a ngbNavLink
          >{{ apollo ? 'Resources' : 'Firmware' }}
          @if (getFirmwareDifference()) {
            <span class="ms-2 badge rounded-pill bg-warning">1</span>
          }
        </a>
        <ng-template ngbNavContent>
          <div class="padded-tab">
            <div class="mb-3 row">
              <label class="col-2 col-form-label">Firmware</label>
              <div class="col">
                <input
                  class="form-control"
                  type="text"
                  [formControl]="form.get('firmware')"
                  [class.value-changed]="getFirmwareDifference() != null"
                  placeholder="Firmware" />
                @if (getFirmwareDifference()) {
                  <div class="value-changed">
                    {{ referencePrefix }}{{ getFirmwareDifference() }}
                  </div>
                }
              </div>
              @if (copyConfig) {
                <div class="col-auto">
                  <input
                    class="pt-1"
                    type="checkbox"
                    [formControl]="copyForm.get('firmware')" />
                </div>
              }
            </div>
            <div class="mb-3 row">
              <label class="col-2 col-form-label">Resources</label>
              <div class="col">
                @for (
                  control of form.get('resources').controls;
                  track control;
                  let idx = $index
                ) {
                  <div class="row mb-2">
                    <div class="col">
                      <input
                        class="form-control"
                        type="text"
                        placeholder="Resource"
                        [formControl]="control" />
                    </div>
                    @if (!copyConfig) {
                      <div class="col-auto">
                        <button
                          type="button"
                          class="btn btn-transparent text-dark"
                          (click)="removeResource(control)"
                          (keydown.enter)="removeResource(control)">
                          <i class="fa fa-trash">&nbsp;</i>
                        </button>
                      </div>
                    }
                    @if (copyConfig) {
                      <div class="col-auto">
                        <input
                          class="pt-1"
                          type="checkbox"
                          [formControl]="copyForm.get('resource' + idx)" />
                      </div>
                    }
                  </div>
                }
                <div class="row">
                  <div class="col">
                    <button
                      type="button"
                      class="btn btn-secondary"
                      (click)="addResource()"
                      (keydown.enter)="addResource()">
                      <i class="fa fa-plus">&nbsp;</i>Add resource
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </ng-template>
      </li>
    }

    @for (cat of settingsTree; track cat) {
      <li [ngbNavItem]="cat.name" [id]="cat.name">
        <a ngbNavLink>
          {{ cat.name }}
          @if (getCatChangeCount(cat) > 0) {
            <span class="ms-2 badge rounded-pill bg-warning">{{
              getCatChangeCount(cat)
            }}</span>
          }
        </a>
        <ng-template ngbNavContent>
          @if (apollo) {
            <!-- APOLLO SETTINGS -->
            <div class="padded-tab">
              @for (setting of cat.subcats; track setting) {
                <div class="mb-3 row">
                  <label class="col-2 col-form-label">{{ setting.name }}</label>
                  <div class="col">
                    <ptr-dynamic-input
                      [formControl]="setting.control"></ptr-dynamic-input>
                    @if (getValueDifference(setting, null, cat)) {
                      <div class="value-changed">
                        {{ referencePrefix
                        }}{{ getValueDifference(setting, null, cat) }}
                      </div>
                    }
                  </div>
                  @if (!copyConfig) {
                    <div class="col-auto">
                      <button
                        type="button"
                        class="btn btn-transparent text-dark"
                        (click)="removeSetting(cat, setting)"
                        (keydown.enter)="removeSetting(cat, setting)">
                        <i class="fa fa-trash">&nbsp;</i>
                      </button>
                    </div>
                  }
                  @if (copyConfig) {
                    <div class="col-auto">
                      <input
                        class="pt-1"
                        type="checkbox"
                        [formControl]="setting.copyControl" />
                    </div>
                  }
                </div>
              }
              <div class="mb-3 row">
                <div class="col offset-3">
                  @if (!showAddSettingForm) {
                    <button
                      class="btn btn-secondary"
                      type="button"
                      (click)="showAddSetting(cat.code, cat.code)"
                      (keydown.enter)="showAddSetting(cat.code, cat.code)">
                      <i class="fa fa-plus">&nbsp;</i>Add setting
                    </button>
                  }
                </div>
              </div>
              @if (showAddSettingForm) {
                <div class="mb-3 row" [formGroup]="addSettingForm">
                  <div class="col-2">
                    <input
                      class="form-control"
                      type="text"
                      placeholder="Setting name"
                      formControlName="key" />
                  </div>
                  <div class="col">
                    <ptr-dynamic-input
                      placeholder="Setting value"
                      formControlName="value"></ptr-dynamic-input>
                  </div>
                  <div class="col-auto">
                    <button
                      class="btn btn-secondary"
                      type="button"
                      (click)="addSetting()"
                      (keydown.enter)="addSetting()">
                      <i class="fa fa-plus"></i>
                    </button>
                    <button
                      class="btn btn-secondary"
                      type="button"
                      (click)="hideAddSettingForm()"
                      (keydown.enter)="hideAddSettingForm()">
                      <i class="fa fa-trash"></i>
                    </button>
                  </div>
                </div>
              }
            </div>
          }
          @if (!apollo) {
            <!-- P6X SETTINGS -->
            <ul ngbNav #tabsub="ngbNav" class="nav-tabs">
              @for (subcat of cat.subcats; track subcat) {
                <li [id]="subcat.name" [ngbNavItem]="subcat.name">
                  <a ngbNavLink
                    >{{ subcat.name | lowercase | ucfirst }}
                    @if (getChangeCount(subcat, cat) > 0) {
                      <span class="ms-2 badge rounded-pill bg-warning">{{
                        getChangeCount(subcat, cat)
                      }}</span>
                    }
                  </a>
                  <ng-template ngbNavContent class="ms-4">
                    <div class="padded-tab">
                      @for (setting of subcat.subcats; track setting) {
                        <div class="mb-3 row">
                          <label class="col-2 col-form-label">{{
                            setting.name | uppercase
                          }}</label>
                          <div class="col">
                            <ptr-dynamic-input
                              [formControl]="
                                setting.control
                              "></ptr-dynamic-input>
                            @if (getValueDifference(setting, subcat, cat)) {
                              <div class="value-changed">
                                {{ referencePrefix
                                }}{{ getValueDifference(setting, subcat, cat) }}
                              </div>
                            }
                          </div>
                          @if (!copyConfig) {
                            <div class="col-auto">
                              <button
                                type="button"
                                class="btn btn-transparent text-dark"
                                (click)="removeSetting(subcat, setting)"
                                (keydown.enter)="
                                  removeSetting(subcat, setting)
                                ">
                                <i class="fa fa-trash">&nbsp;</i>
                              </button>
                            </div>
                          }
                          @if (copyConfig) {
                            <div class="col-auto">
                              <input
                                class="pt-1"
                                type="checkbox"
                                [formControl]="setting.copyControl" />
                            </div>
                          }
                        </div>
                      }
                      <div class="mb-3 row">
                        <div class="col offset-3">
                          @if (!showAddSettingForm) {
                            <button
                              class="btn btn-secondary"
                              type="button"
                              (click)="showAddSetting(cat.code, subcat.name)"
                              (keydown.enter)="
                                showAddSetting(cat.code, subcat.name)
                              ">
                              <i class="fa fa-plus">&nbsp;</i>Add setting
                            </button>
                          }
                        </div>
                      </div>
                      @if (showAddSettingForm) {
                        <div class="mb-3 row" [formGroup]="addSettingForm">
                          <div class="col-2">
                            <input
                              class="form-control"
                              type="text"
                              placeholder="Setting name"
                              formControlName="key" />
                          </div>
                          <div class="col">
                            <ptr-dynamic-input
                              placeholder="Setting value"
                              formControlName="value"></ptr-dynamic-input>
                          </div>
                          <div class="col-auto">
                            <button
                              class="btn btn-secondary"
                              type="button"
                              (click)="addSetting()"
                              (keydown.enter)="addSetting()">
                              <i class="fa fa-plus"></i>
                            </button>
                            <button
                              class="btn btn-secondary"
                              type="button"
                              (click)="hideAddSettingForm()"
                              (keydown.enter)="hideAddSettingForm()">
                              <i class="fa fa-trash"></i>
                            </button>
                          </div>
                        </div>
                      }
                    </div>
                  </ng-template>
                </li>
              }
              <li [ngbNavItem]="'+'">
                <a ngbNavLink>+</a>
                <ng-template ngbNavContent>
                  <!-- <form [formGroup]="subcatForm"> -->
                  <div class="padded-tab">
                    <div class="mb-3 row">
                      <label class="col-3 col-form-label">Name</label>
                      <div class="col">
                        <input
                          class="form-control"
                          type="text"
                          formControlName="subcategory" />
                      </div>
                    </div>
                    <div class="mb-3 row">
                      <div class="col offset-3">
                        <button
                          class="btn btn-secondary"
                          [disabled]="!form.controls.subcategory.valid"
                          (click)="tabsub.activeId = addSubCategory(cat)"
                          (keydown.enter)="
                            tabsub.activeId = addSubCategory(cat)
                          ">
                          Add
                        </button>
                      </div>
                    </div>
                  </div>
                  <!-- </form> -->
                </ng-template>
              </li>
            </ul>
            <div [ngbNavOutlet]="tabsub"></div>
          }
        </ng-template>
      </li>
    }
    <li [ngbNavItem]="'+'">
      <a ngbNavLink>+</a>
      <ng-template ngbNavContent>
        <div class="padded-tab">
          <div class="mb-3 row">
            <label class="col-3 col-form-label">Name</label>
            @if (!apollo) {
              <div class="col">
                <select
                  class="form-select"
                  formControlName="category"
                  (change)="tabmain.activeId = addCategory()">
                  @for (
                    selectedCat of mainCategories.filter(catFilter);
                    track selectedCat
                  ) {
                    <option [ngValue]="selectedCat">
                      {{ selectedCat.name }}
                    </option>
                  }
                </select>
              </div>
            }
            @if (apollo) {
              <div class="col">
                <input
                  class="form-control"
                  type="text"
                  formControlName="category" />
              </div>
            }
          </div>
          @if (apollo) {
            <div class="mb-3 row">
              <div class="col col-2 offset-3">
                <button
                  class="btn btn-secondary"
                  [disabled]="!form.controls.category.valid"
                  (click)="tabmain.activeId = addCategory()"
                  (keydown.enter)="tabmain.activeId = addCategory()">
                  Add
                </button>
              </div>
            </div>
          }
        </div>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="tabmain"></div>
</form>
